export default async function PegaTextosBiblia(
  api,
  livro,
  capitulo,
  versiculos
) {
  try {
    if (versiculos === "") versiculos = "1-999";

    const response = await api.get("verses/", {
      headers: {
        book: livro,
        chapter: capitulo,
        verses: versiculos,
      },
    });

    if (!response)
      throw new Error(
        `Erro pegando texto da bíblia livro: ${livro}, capítulo ${capitulo}, versículo(s) ${versiculos}`
      );

    var texto = `*[bookName] ${capitulo}[verses]*
`;
    var bookName = "";
    var maxVerse = 0;
    response.data.forEach((item) => {
      bookName = item.BookName;
      maxVerse = item.MaxVerse;
      texto = `${texto}_${item.verse}_ ${item.text}

`;
    });

    return { bookName, maxVerse, texto };
  } catch (error) {
    throw new Error(
      `Erro pegando texto da bíblia livro: ${livro}, capítulo ${capitulo}, versículo(s) ${versiculos}: \n${error?.message}`
    );
  }
}
